@file:Suppress("UNUSED_VARIABLE")

package es.cragma.fichajefacil.data

import es.cragma.fichajefacil.model.Company
import es.cragma.fichajefacil.model.ClockInRecord
import es.cragma.fichajefacil.model.User

private fun escapeJson(str: String?): String {
    if (str == null) return ""
    return str
        .replace("\\", "\\\\")
        .replace("\"", "\\\"")
        .replace("\n", "\\n")
        .replace("\r", "\\r")
        .replace("\t", "\\t")
}

actual fun platformSyncCompanyToCloud(company: Company) {
    try {
        val json = """{"id":"${escapeJson(company.id)}","name":"${escapeJson(company.name)}","cif":"${escapeJson(company.cif)}","address":"${escapeJson(company.address)}","city":"${escapeJson(company.city)}","country":"${escapeJson(company.country)}","plan":"${company.plan.name}","maxEmployees":${company.maxEmployees}}"""
        js("if (window.callSyncCompanyWeb) window.callSyncCompanyWeb(json)")
    } catch (e: Throwable) {
        println("JS sync company error: $e")
    }
}

actual fun platformSyncEmployeeToCloud(user: User) {
    try {
        val json = """{"id":"${escapeJson(user.id)}","firstName":"${escapeJson(user.firstName)}","lastName":"${escapeJson(user.lastName)}","email":"${escapeJson(user.email)}","phone":"${escapeJson(user.phone)}","companyId":"${escapeJson(user.companyId ?: "global")}","role":"${user.role.name}","position":"${escapeJson(user.position)}","department":"${escapeJson(user.department)}","isActive":${user.isActive}}"""
        js("if (window.callSyncEmployeeWeb) window.callSyncEmployeeWeb(json)")
    } catch (e: Throwable) {
        println("JS sync employee error: $e")
    }
}

actual fun platformSyncClockInToCloud(record: ClockInRecord) {
    try {
        val json = """{"id":"${escapeJson(record.id)}","userId":"${escapeJson(record.userId)}","companyId":"${escapeJson(record.companyId)}","userName":"${escapeJson(record.userName)}","userRole":"${record.userRole.name}","startTimeMillis":${record.startTimeMillis},"endTimeMillis":${record.endTimeMillis ?: 0},"netWorkedMillis":${record.netWorkedMillis},"totalBreakMillis":${record.totalBreakMillis},"startLocation":"${escapeJson(record.startLocation ?: "")}","endLocation":"${escapeJson(record.endLocation ?: "")}","status":"${record.currentStatus.name}"}"""
        js("if (window.callSyncClockInWeb) window.callSyncClockInWeb(json)")
    } catch (e: Throwable) {
        println("JS sync clockIn error: $e")
    }
}

actual fun platformFetchCloudData(onLoaded: (companiesJson: String, usersJson: String) -> Unit) {
    try {
        js("if (window.fetchCloudDataWeb) window.fetchCloudDataWeb(function(jsonStr) { onLoaded(jsonStr, ''); })")
    } catch (e: Throwable) {
        println("JS fetch data error: $e")
    }
}

actual fun platformRegisterCompanyAndAdmin(company: Company, adminUser: User, password: String) {
    try {
        val compJson = """{"id":"${escapeJson(company.id)}","name":"${escapeJson(company.name)}","cif":"${escapeJson(company.cif)}","address":"${escapeJson(company.address)}","city":"${escapeJson(company.city)}","country":"${escapeJson(company.country)}","plan":"${company.plan.name}","maxEmployees":${company.maxEmployees}}"""
        val adminJson = """{"id":"${escapeJson(adminUser.id)}","firstName":"${escapeJson(adminUser.firstName)}","lastName":"${escapeJson(adminUser.lastName)}","email":"${escapeJson(adminUser.email)}","phone":"${escapeJson(adminUser.phone)}","companyId":"${escapeJson(company.id)}","role":"${adminUser.role.name}","position":"${escapeJson(adminUser.position)}","department":"${escapeJson(adminUser.department)}","isActive":${adminUser.isActive}}"""
        val safePassword = escapeJson(password)
        js("if (window.registerCompanyAndAdminWeb) window.registerCompanyAndAdminWeb(compJson, adminJson, safePassword)")
    } catch (e: Throwable) {
        println("JS register company error: $e")
    }
}

actual fun platformFetchUserAccountsFromCloud(
    email: String,
    onResult: (usersAndCompanies: List<Pair<User, Company?>>, clockIns: List<ClockInRecord>) -> Unit
) {
    onResult(emptyList(), emptyList())
}
